/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PostboxInputs */

const en__field_postbox = /** @type {(inputs: _Field_PostboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post box`)
};

const de__field_postbox = /** @type {(inputs: _Field_PostboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauspostfach`)
};

/**
* | output |
* | --- |
* | "Post box" |
*
* @param {_Field_PostboxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_postbox = /** @type {((inputs?: _Field_PostboxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PostboxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_postbox(inputs)
	return de__field_postbox(inputs)
});